export default __webpack_public_path__ + "static/media/piano.7c747d79.mkv";